import React, { useState } from "react";
import { useConfig } from "../../hooks/useConfig";
import { useTV } from "../../hooks/useTV";
import { useStreamTime } from "../../hooks/useStreamTime";
import OffStreamView from "./VIP/OffStreamView";
import useGlobalStore from "../../store/global.store";
import VIPUpgrade from "./VIP/VipUpgrade/VIPUpgrade";
import { useRemote } from "../../hooks/useRemote";

const Stream = ({ device }) => {
  const { config } = useConfig();
  const { isTv } = useTV();
  const { loading, showStream, showStreamLoader, getShowTimeText } =
    useStreamTime();
  const { updateView } = useRemote();

  const [showParks, setShowParks] = useState(false);
  const hasVipAddOn = useGlobalStore((state) => state.hasVipAddOn);
  const showVipUpgrade = useGlobalStore((state) => state.showVipUpgrade);
  const setShowVipUpgrade = useGlobalStore((state) => state.setShowVipUpgrade);

  // Conditionally apply TV-specific styles
  const topBarStyle = {
    height: isTv ? "130px" : "100px",
    background: "#12243F",
    width: "100vw",
    position: "absolute",
    left: 0,
    top: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    zIndex: 20,
    fontFamily: "Lato",
  };

  const fireworksShowTextStyle = {
    fontSize: isTv ? "40px" : "30px",
  };

  const liveLogoStyle = {
    position: "absolute",
    top: "100px",
    right: "0px",
    width: isTv ? "580px" : "340px",
    zIndex: 20,
  };

  const pinButtonStyle = {
    position: "absolute",
    bottom: "90px",
    left: "0px",
    width: isTv ? "220px" : "150px",
    zIndex: 30,
  };

  const balconyStyle = {
    position: "absolute",
    bottom: isTv ? "-35px" : "0",
    left: 0,
    width: "100vw",
    zIndex: 20,
  };

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* 🔄 NEW: VIP glowing button style block */}
      <style>
        {`
  .vip-upgrade-button-wrapper {
    position: absolute;
    bottom: 110px;
    left: 50%;
    transform: translateX(-50%);
    padding: 1px;
    border-radius: 999px;
    background: linear-gradient(
      120deg,
      #ff4d4d,
      #ffcc00,
      #00ff99,
      #0066ff,
      #cc00ff,
      #ff4d4d
    );
    background-size: 300% 300%;
    animation: rainbowBorderMove 6s linear infinite;
    z-index: 48;
  }

  .vip-upgrade-button {
    background-color: #12243F;
    color: white;
    font-family: 'Lato', sans-serif;
    font-size: 22px;
    padding: 14px 36px;
    min-width: 220px;
    min-height: 50px;
    border-radius: 999px;
    font-weight: 700;
    user-select: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    border: 2px solid transparent;
    background-clip: padding-box;
    white-space: nowrap;
  }

  @keyframes rainbowBorderMove {
    0% {
      background-position: 0% 50%;
    }
    100% {
      background-position: 300% 50%;
    }
  }
`}
      </style>

      {loading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            fontSize: "30px",
            color: "blue",
            fontFamily: "Lato",
            zIndex: 50,
          }}
        >
          <span>Loading...</span>
        </div>
      ) : (
        <>
          {showStream === true ? (
            <>
              <div
                style={{
                  position: "absolute",
                  top: showStreamLoader ? 0 : "-100vh",
                  transition: showStreamLoader ? "none" : "top 3s",
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  zIndex: 60,
                  backgroundColor: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  style={{
                    width: "100vw",
                    height: "100vh",
                    objectFit: "cover",
                  }}
                  src="/static/curtainRaiseUSE.jpg"
                  alt=""
                />
              </div>

              <div style={topBarStyle}>
                <span style={fireworksShowTextStyle}>
                  NEXT FIREWORKS SHOW: {getShowTimeText()}
                </span>
              </div>

              <iframe
                title="Stream"
                style={{
                  width: "230vw",
                  height: "100vw",
                  zIndex: 10,
                  position: "absolute",
                  top: 180,
                  right: isTv ? -300 : -190,
                  transform: "rotate(-6deg) scale(1.4)",
                }}
                src={
                  config.streamUrl === 1
                    ? "https://live2.mywaitserver.com/live/player"
                    : "https://live.mywaitserver.com/live/player"
                }
                allowFullScreen=""
                frameBorder="0"
              />

              <img
                src="/static/stream/livelogo.png"
                alt=""
                style={liveLogoStyle}
              />

              <img
                src={
                  showParks
                    ? "/static/stream/pin%20BUTTON%20pressed.png"
                    : "/static/stream/pin%20BUTTON%20not%20pressed.png"
                }
                alt=""
                style={{
                  ...pinButtonStyle,
                  display: isTv ? "none" : "block",
                }}
                onClick={() => setShowParks(!showParks)}
              />

              <img
                src={
                  isTv
                    ? "/static/stream/balcony.png"
                    : "/static/stream/balcony.png"
                }
                alt=""
                style={balconyStyle}
              />

              {showParks && (
                <>
                  <img
                    src="/static/stream/pin%20map.png"
                    alt=""
                    style={{
                      position: "absolute",
                      top: "310px",
                      left: isTv ? "180px" : "200px",
                      width: isTv ? "250px" : "120px",
                      zIndex: 20,
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: isTv ? "400px" : "350px",
                      left: isTv ? "30px" : "110px",
                      width: "fit-content",
                      zIndex: 20,
                      backgroundColor: "white",
                      padding: "0px 20px",
                      border: "6px solid #12243F",
                      fontFamily: "Lato",
                      fontWeight: "800",
                      fontSize: isTv ? "55px" : "25px",
                      borderRadius: "10px",
                    }}
                  >
                    EPCOT
                  </div>

                  <img
                    src="/static/stream/pin%20map.png"
                    alt=""
                    style={{
                      position: "absolute",
                      top: isTv ? "355px" : "335px",
                      left: isTv ? "300px" : "285px",
                      width: isTv ? "250px" : "120px",
                      zIndex: 20,
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: isTv ? "450px" : "380px",
                      left: isTv ? "490px" : "370px",
                      width: "fit-content",
                      zIndex: 20,
                      backgroundColor: "white",
                      padding: "0px 20px",
                      border: "6px solid #12243F",
                      fontFamily: "Lato",
                      fontWeight: "800",
                      fontSize: isTv ? "55px" : "25px",
                      borderRadius: "10px",
                    }}
                  >
                    Disney Springs
                  </div>

                  <img
                    src="/static/stream/pin%20map.png"
                    alt=""
                    style={{
                      position: "absolute",
                      top: isTv ? "320px" : "300px",
                      right: isTv ? "175px" : "75px",
                      width: isTv ? "250px" : "120px",
                      zIndex: 20,
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: isTv ? "410px" : "340px",
                      right: isTv ? "365px" : "165px",
                      width: "fit-content",
                      zIndex: 20,
                      backgroundColor: "white",
                      padding: "0px 20px",
                      border: "6px solid #12243F",
                      fontFamily: "Lato",
                      fontWeight: "800",
                      fontSize: isTv ? "55px" : "25px",
                      borderRadius: "10px",
                    }}
                  >
                    Magic Kingdom
                  </div>
                </>
              )}
              {/* 🔄 NEW: VIP UPGRADE BUTTON (only shows if user doesn't have VIP) */}
              {/* VIP button in-stream: route like BottomBar VIP */}
              {!hasVipAddOn && (
                <div
                  className="vip-upgrade-button-wrapper"
                  style={{ zIndex: 59 }}
                >
                  <button
                    onClick={() => updateView("VIP__upgrade")}
                    className="vip-upgrade-button"
                  >
                    <span>Upgrade For a Closer View!</span>
                  </button>
                </div>
              )}

              {/* 🔄 NEW: VIP Upgrade Modal */}
              {showVipUpgrade && <VIPUpgrade />}
            </>
          ) : (
            showStream === false && <OffStreamView />
          )}
        </>
      )}
    </div>
  );
};

export default Stream;
